import tabs from "assets/json/sideWindowTabs.json";
import searchForTab from "common/searchTab";

const SideWindowState = Object.freeze({
	CLOSED: Symbol(0),
	OPEN: Symbol(1)
});

const initialState = {
	activeTabId: 0,
	currentAddress: new URLSearchParams(window.location.search).get("s") ?? "",
	history: [],
	open: new URLSearchParams(window.location.search).get("s") != null
};

const sideWindowReducer = (state = initialState, action) => {
	if (action.type === "SET_SIDE_WINDOW_ADDRESS") {
		let newAddress = action.state || "";
		let tab = searchForTab(tabs, newAddress);

		while (tab?.needsSubTab) {
			newAddress = newAddress.concat(".", tab.subTabs[0].id);
			tab = searchForTab(tabs, newAddress);
		}

		const searchParams = new URLSearchParams(window.location.search);
		searchParams.set("s", newAddress);
		const l = window.location;
		const newUrl = l.origin + l.pathname + "?" + searchParams.toString() + l.hash;
		window.history.pushState({}, "", newUrl);

		return {
			...state,
			open: newAddress === "" ? SideWindowState.CLOSED : SideWindowState.OPEN,
			currentAddress: newAddress,
			history: action.preserveHistory === false ? state.history : [...state.history, state.currentAddress]
		};
	}

	if (action.type === "SET_SIDE_WINDOW_HISTORY") {
		return { ...state, history: action.state };
	}

	if (action.type === "SIDE_WINDOW_SET") {
		return action.state;
	}

	return state;
};

export default sideWindowReducer;
export { sideWindowReducer, SideWindowState };
